<template>
  <div id="wrapper_map">
      <div id="map_overlay">
          <div id="map_message" class="card card-map">
              <p class="mb-2"><b-icon-cursor-fill class="p-0 m-0"></b-icon-cursor-fill> {{ translationData.trackingLocation }}</p>
              <b-row class="w-100 m-0">
                    <b-col sm="6" cols="p-0">
                        <p class="m-0 label_sync">{{ translationData.distanceDestine }} </p>
                        <strong><p name="last_app_sync_time" class="m-0 text_sync"> {{ this.calculateDistance(this.info.data.distribution[0].last_app_sync_lat, 
                                                                                                    this.info.data.distribution[0].last_app_sync_long, 
                                                                                                    this.info.data.documentInfo.latitude, 
                                                                                                    this.info.data.documentInfo.longitude, 
                                                                                                    "K") }} </p></strong>
                    </b-col>
                    <b-col sm="6" cols="p-0">
                        <p class="m-0 text-md-right label_sync">{{ translationData.lastUpdate }}</p>
                        <strong><p name="last_app_sync_time" class="m-0 text-md-right text_sync"> {{ this.info.data.distribution[0].last_app_sync | moment("utc","DD/MM/YYYY HH:mm") }} </p></strong>
                    </b-col>
                </b-row>
                <p class="p-0 m-0 label_warning text-center">*{{ translationData.messageUpdate }}</p>
            </div>
      </div>
      <div ref="map" v-bind:style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
import TranslationEs from '../locale/esp/translation_esp.json'
import TranslationPt from '../locale/pt/translation_pt.json'
export default {
    name: 'Map',
    props: ['info'],
    data() {
        return {
            map: {},
            platform: {},
            api_key: process.env.VUE_APP_HERE_API_KEY,
            language: null,
            translationData: {}
        }
    },
      created() {
    const url = window.location.href;
    const langParam = 'lang=';
    const langIndex = url.indexOf(langParam);

    if (langIndex !== -1) {
      const langValue = url.substring(langIndex + langParam.length);
      this.language = langValue;
    } else {
      // Se o parâmetro "lang" não for encontrado, defina um idioma padrão (por exemplo, português)
      this.language = 'pt';
    }

    if (this.language === 'esp' && TranslationEs) {
      this.translationData = TranslationEs;
    } else {
      this.translationData = TranslationPt;
    }
  },
    async mounted() { 
        const platform = new window.H.service.Platform({
            apikey: this.api_key
        });
        this.platform = platform;
        this.initializeHereMap();
    },
    methods:{
        initializeHereMap() {
            const mapContainer = this.$refs.map;
            const H = window.H;
            
            var maptypes = this.platform.createDefaultLayers();
            this.map = new H.Map(mapContainer, maptypes.vector.normal.map,{
                padding: {top: 100, left: 100, bottom: 100, right: 100}
            });

            //ícone do pacote
            var icon = new H.map.Icon("./pin.svg");      
            var markerPackage = new H.map.Marker({lat: this.info.data.distribution[0].last_app_sync_lat, lng: this.info.data.distribution[0].last_app_sync_long }, {icon: icon});
            //ícone do endereço do cliente
            icon = new H.map.Icon("./pin_house.svg");      
            var markerHome = new H.map.Marker({lat: this.info.data.documentInfo.latitude, lng: this.info.data.documentInfo.longitude }, {icon: icon});
            var group = new H.map.Group();
            group.addObjects([markerPackage, markerHome]);
            this.map.addObject(group);
            this.map.getViewModel().setLookAtData({
                bounds: group.getBoundingBox()
            });
        },
        calculateDistance(lat1, lon1, lat2, lon2, unit) {
            if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
            }else{
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var theta = lon1-lon2;
                var radtheta = Math.PI * theta/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit=="K") { dist = dist * 1.609344 }
                if (unit=="N") { dist = dist * 0.8684 }

                if(dist < 1){
                    return ((dist*1000).toFixed(0) + " m");
                }else{
                    return (dist.toFixed(2) + " km");
                }
            }
        }
    }
}
</script>
               
<style>
#wrapper_map{
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 400px;
}

#map_overlay{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 10;

    -webkit-box-shadow: inset 0px 0px 20px 0px rgba(0,0,0,0.30);
    -moz-box-shadow: inset 0px 0px 20px 0px rgba(0,0,0,0.30);
    box-shadow: inset 0px 0px 20px 0px rgba(0,0,0,0.30);
}

#map_message{
    width: calc(100% - 30px);
    position: absolute;
    bottom: 0;
    margin: 10px;
    padding: 10px;
}

.card-map{
     border-top: 2px solid #5ed195 !important;
}

.label_sync{
    color: rgb(167, 167, 167);
    font-size: 12px;
}

.label_warning{
    font-size: 10px;
    color: rgb(167, 167, 167);
}
</style>
